import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-monthly-allowances',
    name: 'pay-monthly-allowance',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-monthly-allowance')
  }
]
